<template>
  <div class="container">
    <img class="colofon" src="@/assets/images/colofon.png" />
    <img class="logo" src="@/assets/images/logo.png" />
    <v-button class="play" :icon="playing ? 'stop' : 'play'" outline @click="playPause"/>
    <ul class="list">
      <li v-for="character in characters" :key="character.name" class="list__item">
        <h2>{{ character.name }}</h2>
        <div>
          <img v-for="id in character.stories" v-if="history.includes(id)" :key="id" src="@/assets/images/check_on.png"/>
          <img v-else src="@/assets/images/check_off.png"/>
        </div>
      </li>
    </ul>
    <v-button class="continue" icon="walk" label="Verder wandelen" primary large @click="resume"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AudioPlayer from '@/AudioPlayer'
import Button from '@/components/Button'
import { defer } from '@/utils'
import characters from '@/data/characters'

const AUDIO_EVENTS = [ 'play', 'pause', 'loadstart' ]

export default {
  name: 'EndView',
  components: {
    'v-button': Button
  },
  data () {
    return {
      characters,
      playing: false
    }
  },
  computed: mapState([
    'history'
  ]),
  methods: {
    ...mapActions([
      'reset',
      'loadScene'
    ]),
    playPause () {
      if (this.playing) {
        AudioPlayer.pause().reset()
        this.playing = false
      } else {
        AudioPlayer.play()
        this.playing = true
      }
    },
    resume () {
      this.track('resume_session', {
        event_category: 'session'
      })
      defer(100, () => {
        this.loadScene({ name: 'SelectCharacter' })
      })
    },
    onAudioChanged (e) {
      this.playing = (e.type === 'play')
    }
  },
  created () {
    AUDIO_EVENTS.forEach(e => AudioPlayer.on(e, this.onAudioChanged))
  },
  mounted () {
    AudioPlayer.load('audio/characters/wouter/end.mp3')
    defer(1000, () => AudioPlayer.play())
  },
  beforeDestroy () {
    AudioPlayer.pause()
    AUDIO_EVENTS.forEach(e => AudioPlayer.off(e, this.onAudioChanged))
  }
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
  width: 100%;
  max-width: 48rem;
  padding: 6rem 0;
  @include fade-in(400ms, 1s);
}

.continue {
  position: fixed;
  bottom: 3rem;
  left: calc(50% - 3.6rem);
}

.reset {
  position: fixed;
  top: 3rem;
  right: 3rem;
}

.colofon {
  position: fixed;
  top: 0;
  right: 0;
  width: 18rem;
}

.logo {
  margin-bottom: 3rem;
}

.play {
  position: absolute;
  top: 18rem;
  left: 1.5rem;
}

.list {
  list-style: none;
  text-align: right;
  margin-bottom: 3rem;
}

.list__item {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  h2 {
    display: inline-block;
    margin-bottom: 1.5rem;
    line-height: 3.0rem;
    text-transform: capitalize;
  }

  div {
    width: 12rem;
    display: inline-block;
  }

  img {
    width: 2.4rem;
    margin: 0.3rem;
  }
}
</style>
